var map = {
	"./MSMT_logotyp_text_CMYK_eng-01.png": 765,
	"./Pardubice_logo_1C.png": 766,
	"./RSJ-F-lg-RGB.png": 767,
	"./UCL_Logo_var1_clr1_CMYK-01.png": 768,
	"./jcmf.png": 769,
	"./logo__gypce.png": 770,
	"./mff.png": 771,
	"./pardubic_kraj.png": 772,
	"./univer pardubice.png": 773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;